import { useRecoilValue } from "recoil";
import {
  LiveSettingHeader,
  LiveSettingPopupWrapper,
  LiveSettingTableHeader,
  LiveSettingTableWrapper,
  LiveTableBorder,
} from "./style";
import LiveList from "./component/live-list";
import { useEffect, useState } from "react";
import { pubState } from "../../../../../../recoil/pub.atom";
import { pushYoutubeList } from "../../../../../../api/youtube-live";
import { MemberSearchBox } from "../../../../../member/style";
import { useTournamentContext } from "../../../../hook/context";

const LiveSetting = () => {
  const pub = useRecoilValue(pubState);
  const { allLiveList, setLiveList, isPush, setIsPush, tournamentId } =
    useTournamentContext();
  const [search, setSearch] = useState("");

  const handlePush = async () => {
    if (!pub || !tournamentId) return;
    if (isPush) {
      alert("이미 푸시메시지를 발송했습니다.");
      return;
    }

    const liveOnYoutuber = allLiveList
      .sort((a, b) => (a?.order || 0) - (b?.order || 0))
      .filter((item) => item.isLive === true)
      .map((item) => item.name)
      .join(", ");

    if (!liveOnYoutuber) return;

    const confirm = window.confirm(
      `전체 매장 회원에게 아래 내용으로 푸시가 발송됩니다. 발송 하시겠습니까? \n\n⭐️${liveOnYoutuber}⭐️ \nLIVE ON! 🃏 러너러너 앱에서 확인하세요! 🎥`,
    );
    if (!confirm) return;

    const request = {
      tournamentId,
      title: `⭐️${liveOnYoutuber}⭐️`,
      pubId: pub.id,
      description: `LIVE ON! 🃏 러너러너 앱에서 확인하세요! 🎥`,
    };
    try {
      await pushYoutubeList(request);
      alert("전송되었습니다. ");
      setIsPush(true);
    } catch (e) {
      console.error(e);
    }
  };

  const onSearch = () => {
    const filteredList = allLiveList.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase()),
    );
    setLiveList(filteredList);
  };

  useEffect(() => {
    onSearch();
  }, [search]);

  return (
    <LiveSettingPopupWrapper>
      <LiveSettingHeader>
        <MemberSearchBox>
          <input
            type="text"
            placeholder="검색어를 입력하세요. "
            value={search}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                onSearch();
              }
            }}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <div className="searchIcon" onClick={onSearch}>
            <img
              src="/image-web/timer-config/searchIcon.svg"
              alt="검색 아이콘"
            />
          </div>
        </MemberSearchBox>
        <div className="right">
          <div className="info">
            *푸시메시지는 토너먼트당 1회만 발송가능합니다.
          </div>
          <div onClick={handlePush} className={`${isPush ? "" : "on"} button`}>
            PUSH 발송
          </div>
        </div>
      </LiveSettingHeader>
      <LiveSettingTableWrapper>
        <LiveSettingTableHeader>
          <div className="ord">우선순위</div>
          <div className="name">채널명</div>
          <div className="link">라이브 방송 링크</div>
          <div className="toggle">LIVE ON/OFF</div>
        </LiveSettingTableHeader>
        <LiveTableBorder />
        <LiveList />
      </LiveSettingTableWrapper>
    </LiveSettingPopupWrapper>
  );
};

export default LiveSetting;
